import { render, staticRenderFns } from "./FolderForm.vue?vue&type=template&id=24b3f1d0&scoped=true&lang=pug&"
import script from "./FolderForm.vue?vue&type=script&lang=ts&"
export * from "./FolderForm.vue?vue&type=script&lang=ts&"
import style0 from "./FolderForm.vue?vue&type=style&index=0&id=24b3f1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3f1d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
